import { usePolfEventQuery } from '@/__generated__/hooks'

// Lightweight read of an event's mode from the Apollo cache. EventDetailShell
// already runs the full polfEvent query, so this almost always hits the cache.
// Returns null while loading, when no eventId is provided, or when the cache
// hasn't seen this event yet (the nav simply falls back to non-team-mode tabs).
export const useEventMode = (eventId: string | null): string | null => {
  const { data } = usePolfEventQuery({
    variables: { polfEventId: eventId ?? '' },
    skip: !eventId,
    fetchPolicy: 'cache-first',
  })
  return data?.polfEvent?.mode ?? null
}
